<template>
    <div class="product-add mt30">
        <!--form表单-->
        <el-form size="small" ref="form" :model="form" label-width="200px">
            <el-form-item label="">
                <div class="edit_container">
                    <Uediter v-if="!loading" :text="form.values.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
                </div>
            </el-form-item>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="primary" @click="onSubmit" :loading="loading" v-auth="'/education/setting/index'" >提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { getSetting, setSetting } from '@/api/education'
    import Upload from "@/components/file/Upload";
    import Uediter from '@/components/UE.vue';

    export default {
        name: 'user-agreement-setting',
        components: {
            Upload,
            Uediter,
        },
        data() {
            return {
                /*富文本框配置*/
                ueditor: {
                    text: '',
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                /*form表单数据*/
                form: {
                    key: 'user_agreement',
                    describe: '用户协议',
                    values: {
                        content: '',
                    }
                },
                /*是否正在加载*/
                loading: true
            };
        },
        props: {

        },
        created() {
            this.getSet()
        },
        methods: {
            //提交表单
            onSubmit() {
                this.loading = true;
                setSetting(this.form)
                    .then(data => {
                        this.loading = false;
                        this.$message({
                            message: '恭喜你，设置成功',
                            type: 'success'
                        });

                    })
                    .catch(error => {
                        this.loading = false;
                    });
            },

            // 获取配置
            getSet(){
                getSetting({key: this.form.key}).then((result)=>{
                    if(result.data.values){
                        this.form.values = Object.assign(this.form.values, result.data.values)
                    }
                    this.loading = false;
                })
            },

            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.values.content = e
            },
        }
    };
</script>

<style>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/setting/part/user-agreement.vue